import { healthSchema } from '@instanexus/contracts';
import { dataEnvelopeSchema, HEALTH_PATH } from '../transport.js';
const healthEnvelopeSchema = dataEnvelopeSchema(healthSchema);
export function createHealthResource(transport) {
    return {
        async get() {
            const envelope = await transport.request({
                path: HEALTH_PATH,
                schema: healthEnvelopeSchema,
            });
            return envelope.data;
        },
    };
}
//# sourceMappingURL=health.js.map